import { Injectable, Output, EventEmitter } from '@angular/core';
import { Moment } from 'moment';
import { GenericSearchConfig } from '../entities/generic-search-config';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import API from '../../common/services/api.config.json';
import { Observable } from 'rxjs';
import { DoctorService } from '../../doctor/services/doctor.service';
import { DateHelper } from 'app/modules/common/helpers/DateHelper';
import { ApiService } from 'app/modules/common/services/api.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import { EmployeeSelectionFilters } from '../entities/employee-search-modal';
import { EmployeeService } from 'app/modules/employee/services/employee.service';
import { EmployeeStoreService } from 'app/modules/employee/services/employee-store.service';
import { ReportsCommonService } from 'app/modules/reports/services/reports-common.service';
import { map } from 'rxjs/operators';
import {
    MatSnackBar,
    MatSnackBarRef,
    SimpleSnackBar,
} from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { LeaveSelectionFilters } from '../entities/leave-search-modal';
import { SelectionPermissions } from '../entities/selection-permissions';
import { PageEvent } from '@angular/material/paginator';
import { TaskSelectionFilters } from '../entities/task-search-modal';
import { TaskTransferTypes } from 'app/modules/common/enums/task-transfer-types';
import { UntypedFormControl, Validators } from '@angular/forms';
import { ActuationSelectionFilter } from '../entities/actutaion-selection-modal';
import { TreeView } from '../components/main-filters/more-filter-popup/actuation-filter/action-type-tree-view/action-type-tree-view.component';
import { ChangeTaskModel } from 'app/modules/common/entities/change-task.model';
import { ResponseStatus } from 'app/modules/common/enums/common-enums';
import { TaskSaveService } from 'app/modules/task/services/task-save.service';
import { LeaveService } from 'app/modules/leave/services/leave.service';
import { ActuationService } from 'app/modules/employee-view/services/actuation.service';
import Utils from 'app/Utils';
@Injectable()
export class SelectionGenericService {
    private searchConfig: GenericSearchConfig;
    loggedMedicoId: string;
    selectedCompanyId: string;
    isLoading = false;
    isTaskTranserLoading = false;
    public dataSource = new MatTableDataSource<any>();
    public paginationProps = new PageEvent();
    public ActivityList: TreeView[];
    
    public displayedColumns = [
        'fecha',
        'hora',
        'empresa',
        'trabajador',
        'tarea',
        'action',
    ];
    loggedDoctorName: string;
    FromDate: Moment = null;
    ToDate: Moment = null;
    isShowLeavePanel = true;
    @Output() showSidePanelEmitter: EventEmitter<boolean> = new EventEmitter();
    @Output() excecuteMoreFilter: EventEmitter<void> = new EventEmitter();
    @Output() rowDataForLeaveReport: EventEmitter<any> = new EventEmitter();
    selectedListRow: any;
    permissionsList: any = [];

    selectionPermissions: SelectionPermissions = new SelectionPermissions();
    public employeeFilter = new UntypedFormControl('',Validators.minLength(4));
    /* 
      THIS MODAL KEEPS A COPY OF THE FILTERS USED FOR THE RESULT SET 
      To maintain an unchanged filter set when needed for taspasar and other similar functionalities
    */

    // Employee Selection
    employeeSelectionModal: EmployeeSelectionFilters =
        new EmployeeSelectionFilters();
    employeeResultModal: EmployeeSelectionFilters =
        new EmployeeSelectionFilters();

    // Leave Selection
    public leaveSelectionModal: LeaveSelectionFilters = new LeaveSelectionFilters();
    public leaveResultModal: LeaveSelectionFilters = new LeaveSelectionFilters();
    
    // Task Selection
    taskSelectionModal: TaskSelectionFilters = new TaskSelectionFilters();
    taskResultModal: TaskSelectionFilters = new TaskSelectionFilters();
    public TaskTransferInput: UntypedFormControl;

    // Action Selection
    ActuationSelectionModal: ActuationSelectionFilter =
        new ActuationSelectionFilter();
    ActuationResultModal: ActuationSelectionFilter =
        new ActuationSelectionFilter();

    hasPrintPermission: boolean;
    hasDeletePermission: boolean;

    public isRecordingsVisible = false;

    constructor(
        public apiService: ApiService,
        public snackBar: MatSnackBar,
        private doctorService: DoctorService,
        public sharedService: SharedService,
        private employeeService: EmployeeService,
        private employeeStoreService: EmployeeStoreService,
        public taskService: TaskSaveService,
        public leaveService:LeaveService,
        private actuationService: ActuationService,
        private reportsCommonService: ReportsCommonService,
    ) {}

    public cache(config: GenericSearchConfig): void {
        this.searchConfig = config;
    }

    public getCache(): GenericSearchConfig {
        return this.searchConfig;
    }

    initData(): void {
        let currentUser: any = Utils.decrypt(localStorage.getItem('currentUser')) ;
        if (currentUser && currentUser !== null) {
            currentUser = JSON.parse(currentUser);
            if (currentUser.medicoId !== null) {
                this.loggedMedicoId = currentUser.medicoId;
                this.GetDoctor(this.loggedMedicoId);
            }
        }
        this.selectedCompanyId = localStorage.getItem('Empresa');
        this.sharedService.setDataForSelectionTabList();
        this.isShowLeavePanel = true;
        this.ShowHideLeavePanel();
    }

    public GetListForSelection(
        companyId: string,
        doctorId: string,
        fromDate: string,
        toDate: string
    ): Observable<RestResponse> {
        let url = `${API.Selection.getTaskSelection}?CompanyId=${companyId}&DoctorId=${doctorId}`;
        if (fromDate !== null) {
            url = url + `&From=${fromDate}`;
        }
        if (toDate !== null) {
            url = url + `&To=${toDate}`;
        }
        return this.apiService.get(url);
    }

    SearchList(text: string): void {
        this.isLoading = true;
        let formatedFrom = null;
        let fromatedTo = null;
        if (text === 'more') {
            if (this.FromDate !== null && this.FromDate.isValid()) {
                formatedFrom = DateHelper.getUTCDateString(
                    DateHelper.getNativeDate(this.FromDate)
                );
            }
            if (this.ToDate !== null && this.ToDate.isValid()) {
                fromatedTo = DateHelper.getUTCDateString(
                    DateHelper.getNativeDate(this.ToDate)
                );
            }
        }
        this.GetListForSelection(
            this.selectedCompanyId,
            this.loggedMedicoId,
            formatedFrom,
            fromatedTo
        ).subscribe(
            (res) => {
                if (res.code === 0) {
                    const result = res.result;
                    this.dataSource.data = result;
                    this.excecuteMoreFilter.emit();
                    this.isLoading = false;
                }
            },
            (err) => {
                console.error(err);
            }
        );
    }

    GetDoctor(doctorId: string): void {
        this.doctorService.GetDoctor(doctorId).subscribe(
            (res) => {
                if (res.code === 0) {
                    this.loggedDoctorName = res.result.nombre;
                }
            },
            (err) => {
                console.error(err);
            }
        );
    }

    public clearTaskFilter(): void {
        this.ToDate = null;
        this.FromDate = null;
        this.taskSelectionModal = new TaskSelectionFilters();
    }

    public ShowSnackBar(
        message: string,
        action: string,
        duration: number
    ): MatSnackBarRef<SimpleSnackBar> {
        return this.snackBar.open(message, action, {
            duration: duration,
        });
    }

    public ShowHideLeavePanel(): void {
        this.isShowLeavePanel = this.isShowLeavePanel ? false : true;

        if (this.isShowLeavePanel) {
            this.isRecordingsVisible = false;
        }

        if (this.isShowLeavePanel && this.selectedListRow) {
            this.rowDataForLeaveReport.emit(this.selectedListRow);
        }

        this.showSidePanelEmitter.emit(this.isShowLeavePanel);
    }

    public getLeaveRecord(row: any): void {
        this.isShowLeavePanel = true;
        this.isRecordingsVisible = false;

        this.showSidePanelEmitter.emit(this.isShowLeavePanel);
        this.selectedListRow = row;
        this.rowDataForLeaveReport.emit(this.selectedListRow);
    }

    public getGeneralLeaveData(employeeId: any): Observable<RestResponse> {
        let url = `${API.Leave.getGeneralLeaveData}`;
        url = url.replace('{employeeId}', employeeId.toString());
        return this.apiService.get(url);
    }

    public getCurrentUserPermissions(): void {
        this.permissionsList = this.sharedService.getCurrentUserPermissions();
    }

    // NEW: CREATING COMMON CALLS ON GENERIC SEVICE

    setPermissionForContextMenu(): void {
        const localPermits = Utils.decrypt(localStorage.getItem('permissionIds'));
        const permissions = localPermits ? localPermits.split(',') : [];

        if (permissions.includes('625')) {
            this.hasPrintPermission = true;
        }

        if (permissions.includes('617')) {
            this.hasDeletePermission = true;
        }

        // PERMISSIONS USED IN EMPLOYEE SELECTION
        if (permissions.includes('314')) {
            this.selectionPermissions.HasUnlock = true;
        }
        if (permissions.includes('614')) {
            this.selectionPermissions.HasDelete = true;
        }
        if (permissions.includes('309')) {
            this.selectionPermissions.HasAlarma = true;
            this.selectionPermissions.HasAviso = true;
        }
        if (permissions.includes('308')) {
            this.selectionPermissions.HasConsentimento = true;
        }
        if (permissions.includes('205')) {
            this.selectionPermissions.HasExcel = true;
        }
        if (permissions.includes('206')) {
            this.selectionPermissions.HasWord = true;
        }
        // PERMISSIONS USED IN LEAVE SELECTION
        if (permissions.includes('505')) {
            this.selectionPermissions.HasDiagnosis = true;
            this.selectionPermissions.HasChronicalMark = true;
            this.selectionPermissions.HasPregnedMark = true;
            this.selectionPermissions.HasSurgeryMark = true;
            this.selectionPermissions.HasPermisos505 = true;
            this.selectionPermissions.HasDiagnosisMark = true;
        }
        if (permissions.includes('516')) {
            this.selectionPermissions.HasPsychosocialRisks = true;
        }
        if (permissions.includes('306')) {
            this.selectionPermissions.HasCompanyMark = true;
            this.selectionPermissions.HasMutualityMark = true;
            this.selectionPermissions.HasZoneMark = true;
            this.selectionPermissions.HasUrgentPositionMark = true;
        }
        if (permissions.includes('223')) {
            this.selectionPermissions.HasExternalMark = true;
            this.selectionPermissions.HasMarcaExternalView = true;
        }
        if (permissions.includes('305')) {
            this.selectionPermissions.HasAbsenteismMark = true;
        }
        if (permissions.includes('211')) {
            this.selectionPermissions.HasDischargeDateBeforeTaskMark = true;
            this.selectionPermissions.HasWithoutEstimatedMark = true;
            this.selectionPermissions.HasWithoutManagingMark = true;
            this.selectionPermissions.HasLeavesWithoutTasksMark = true;
            this.selectionPermissions.HasWithoutVisitsMark = true;
        }
        if (permissions.includes('409')) {
            this.selectionPermissions.HasPES = true;
        }
        if (permissions.includes('212')) {
            this.selectionPermissions.HasMarcaView = true;
        }
        if (permissions.includes('515')) {
            this.selectionPermissions.HasEmbarazada = true;
        }

        if (permissions.includes('305')) {
            this.selectionPermissions.HasAbsentista = true;
        }
        if (permissions.includes('222')) {
            this.selectionPermissions.HasPermisos222 = true;
        }
        if (permissions.includes('510')) {
            this.selectionPermissions.HasPermisos510 = true;
            this.selectionPermissions.HasTereaRealizada = true;
            this.selectionPermissions.HasTereaEnvio = true;
        }
        if (permissions.includes('517') && permissions.includes('518')) {
            this.selectionPermissions.HasTereaSelectionComentario = true;
        }

        if (permissions.includes('510')) {
            this.selectionPermissions.HasUsuario = true;
            this.selectionPermissions.HasPermisos510 = true;
        }

        if (permissions.includes('511')) {
            this.selectionPermissions.HasFechaRevision = true;
            this.selectionPermissions.HasPermisos511 = true;
        }

        if (permissions.includes('502')) {
            this.selectionPermissions.HasFacturacion = true;
        }

        if (permissions.includes('519')) {
            this.selectionPermissions.HasGrabacion = true;
        }

        if (permissions.includes('520')) {
            this.selectionPermissions.HasDocumento = true;
        }

        if (permissions.includes('514') && permissions.includes('510')) {
            this.selectionPermissions.HasImporteMedico = true;
        }

        if (permissions.includes('501')) {
            this.selectionPermissions.HasTexto = true;
        }

        if (permissions.includes('619')) {
            this.selectionPermissions.HasRespSol = true;
        }

        if (permissions.includes('208')) {
            this.selectionPermissions.HasPermisos208 = true;
        }

        if (permissions.includes('215')) {
            this.selectionPermissions.HasTereaFReclamacion = true;
            this.selectionPermissions.HasTereaReclTelefonica = true; 
            this.selectionPermissions.HasTereaReclUSuario = true;
            this.selectionPermissions.HasTereaReclObs = true;
        }
        if (permissions.includes('405')) {
            this.selectionPermissions.HasPermisos405 = true;
           
        }
    }

    GoToEmployee(trabajadorId, leaveId?: number): any {
        this.getEmployee(trabajadorId).subscribe((res) => {
            localStorage.setItem('EmplooyeeID', trabajadorId);

            localStorage.removeItem('LeaveID');
            if (leaveId) {
                localStorage.setItem('LeaveID', String(leaveId));
            }
            const url =
                window.location.protocol +
                '//' +
                window.location.host +
                '/#/employee';
            window.open(url);
        });
    }

    getEmployee(employeeId: any): any {
        return this.employeeService.GetTrabDetail(employeeId).pipe(
            map((res) => {
                const employee = res.result;
                this.employeeStoreService.employee = employee;
                return res;
            })
        );
    }

    public SearchEmployees(
        pageIndex: number,
        pageSize: number,
        initialCall: boolean
    ): any {
        this.isLoading = true;
        this.employeeSelectionModal.PageIndex = pageIndex;
        this.employeeSelectionModal.PageSize = pageSize;
        this.employeeResultModal.PageIndex = pageIndex;
        this.employeeResultModal.PageSize = pageSize;

        this.GetSelectionResults(initialCall).subscribe(
            (res) => {
                if (res.code === 0) {
                    const result = res.result;
                    this.paginationProps.pageSize = result.pageSize;
                    this.paginationProps.pageIndex = result.pageIndex;
                    this.paginationProps.length = result.length;
                    this.dataSource.data = result.trabajadorFilterLists;

                    if (initialCall) {
                        this.employeeResultModal = Object.assign(
                            {},
                            this.employeeSelectionModal
                        );
                    }
                } else if(res.code === ResponseStatus.TimeOut) 
                {
                    this.dataSource.data = [];
                    this.sharedService.ShowSnackBar(
                        'Limite su búsqueda y vuelva a intentarlo más tarde.',
                        'okay',
                        2000
                    );
                    console.error(res.message);
                } else {
                    this.dataSource.data = [];
                    this.sharedService.ShowSnackBar(
                        'Ha ocurrido un error. Por favor intente de nuevo',
                        'okay',
                        2000
                    );
                    console.error(res.message);
                }
                this.isLoading = false;
            },
            (err) => {
                this.dataSource.data = [];
                this.isLoading = false;
                this.sharedService.ShowSnackBar(
                    'Ha ocurrido un error. Por favor intente de nuevo',
                    'okay',
                    2000
                );
                console.error(err);
            }
        );
    }

    public SearchLeaves(
        pageIndex: number,
        pageSize: number,
        initialCall: boolean
    ): any {
        this.isLoading = true;
        this.leaveSelectionModal.PageIndex = pageIndex;
        this.leaveSelectionModal.PageSize = pageSize;
        this.leaveResultModal.PageIndex = pageIndex;
        this.leaveResultModal.PageSize = pageSize;
        this.GetSelectionResults(initialCall).subscribe(
            (res) => {
                if (res.code === 0) {
                    const result = res.result;
                    this.paginationProps.pageSize = result.pageSize;
                    this.paginationProps.pageIndex = result.pageIndex;
                    this.paginationProps.length = result.length;
                    this.dataSource.data = result.bajaFilterList;

                    if (initialCall) {
                        this.leaveResultModal = Object.assign(
                            {},
                            this.leaveSelectionModal
                        );
                    }
                } else if(res.code === ResponseStatus.TimeOut) 
                {
                    this.dataSource.data = [];
                    this.sharedService.ShowSnackBar(
                        'Limite su búsqueda y vuelva a intentarlo más tarde.',
                        'okay',
                        2000
                    );
                    console.error(res.message);
                } else {
                    this.dataSource.data = [];
                    this.sharedService.ShowSnackBar(
                        'Ha ocurrido un error. Por favor intente de nuevo',
                        'okay',
                        2000
                    );
                    console.error(res.message);
                }

                this.isLoading = false;
            },
            (err) => {
                this.dataSource.data = [];
                this.isLoading = false;
                this.sharedService.ShowSnackBar(
                    'Ha ocurrido un error. Por favor intente de nuevo',
                    'okay',
                    2000
                );
                console.error(err);
            }
        );
    }

    public SearchTasks(
        pageIndex: number,
        pageSize: number,
        initialCall: boolean
    ): any {
        this.isLoading = true;
        this.taskSelectionModal.PageIndex = pageIndex;
        this.taskSelectionModal.PageSize = pageSize;
        this.taskResultModal.PageIndex = pageIndex;
        this.taskResultModal.PageSize = pageSize;

        this.GetSelectionResults(initialCall).subscribe(
            (res) => {
                if (res.code === 0) {
                    const result = res.result;
                    this.paginationProps.pageSize = result.pageSize;
                    this.paginationProps.pageIndex = result.pageIndex;
                    this.paginationProps.length = result.length;
                    this.dataSource.data = result.tareaFilterList;

                    if (initialCall) {
                        this.taskResultModal = Object.assign(
                            {},
                            this.taskSelectionModal
                        );
                    }
                } else if(res.code === ResponseStatus.TimeOut) 
                {
                    this.dataSource.data = [];
                    this.sharedService.ShowSnackBar(
                        'Limite su búsqueda y vuelva a intentarlo más tarde.',
                        'okay',
                        2000
                    );
                    console.error(res.message);
                } else {
                    this.dataSource.data = [];
                    this.sharedService.ShowSnackBar(
                        'Ha ocurrido un error. Por favor intente de nuevo',
                        'okay',
                        2000
                    );
                    console.error(res.message);
                }
                this.isLoading = false;
            },
            (err) => {
                this.dataSource.data = [];
                this.isLoading = false;
                this.sharedService.ShowSnackBar(
                    'Ha ocurrido un error. Por favor intente de nuevo',
                    'okay',
                    2000
                );
                console.error(err);
            }
        );
    }

    public GetActuationSelection(
        pageIndex: number,
        pageSize: number,
        initialCall: boolean
    ): any {
        this.isLoading = true;
        this.ActuationSelectionModal.PageIndex = pageIndex;
        this.ActuationSelectionModal.PageSize = pageSize;
        this.ActuationResultModal.PageIndex = pageIndex;
        this.ActuationResultModal.PageSize = pageSize;
        this.GetSelectionResults(initialCall).subscribe(
            (res) => {
                if (res.code === 0) {
                    const result = res.result;
                    this.paginationProps.pageSize = result.pageSize;
                    this.paginationProps.pageIndex = result.pageIndex;
                    this.paginationProps.length = result.length;
                    this.dataSource.data = result.actuationFilterList;

                    if (initialCall) {
                        this.ActuationResultModal = Object.assign(
                            {},
                            this.ActuationSelectionModal
                        );
                    }
                } else if(res.code === ResponseStatus.TimeOut) 
                {
                    this.dataSource.data = [];
                    this.sharedService.ShowSnackBar(
                        'Limite su búsqueda y vuelva a intentarlo más tarde.',
                        'okay',
                        2000
                    );
                    console.error(res.message);
                } else {
                    this.dataSource.data = [];
                    this.sharedService.ShowSnackBar(
                        'Ha ocurrido un error. Por favor intente de nuevo',
                        'okay',
                        2000
                    );
                    console.error(res.message);
                }
                this.isLoading = false;
            },
            (err) => {
                this.dataSource.data = [];
                this.isLoading = false;
                this.sharedService.ShowSnackBar(
                    'Ha ocurrido un error. Por favor intente de nuevo',
                    'okay',
                    2000
                );
                console.error(err);
            }
        );
    }

    private GetSelectionResults(
        initialCall: boolean
    ): Observable<RestResponse> {
        let url = '';
        switch (this.sharedService.selectedSelectionTabId) {
            case 1:
                this.employeeSelectionModal.EmpresaID = Number(
                    this.selectedCompanyId
                );
                url = `${API.Selection.getEmployeeSelection}`;

                if (initialCall) {
                    return this.apiService.post(
                        url,
                        this.employeeSelectionModal
                    );
                } else {
                    return this.apiService.post(url, this.employeeResultModal);
                }

            case 2:
                this.leaveSelectionModal.EmpresaID = Number(
                    this.selectedCompanyId
                );
                url = `${API.Selection.getLeaveSelection}`;
                if (initialCall) {
                    this.reportsCommonService.setFiltros(this.leaveSelectionModal);
                    return this.apiService.post(url, this.leaveSelectionModal);
                } else {
                    return this.apiService.post(url, this.leaveResultModal);
                }

            case 3:
                this.ActuationSelectionModal.EmpresaID = Number(
                    this.selectedCompanyId
                );
                url = `${API.Selection.getActuationSelection}`;

                if (initialCall) {
                    return this.apiService.post(
                        url,
                        this.ActuationSelectionModal
                    );
                } else {
                    return this.apiService.post(url, this.ActuationResultModal);
                }

            case 5:
                this.taskSelectionModal.CompanyId = Number(
                    this.selectedCompanyId
                );

                if (!this.selectionPermissions.HasPermisos510) {
                    this.taskSelectionModal.DoctorId = Number(
                        this.loggedMedicoId == null ? 0 :  this.loggedMedicoId
                    );
                }

                if (this.FromDate !== null) {
                    this.taskSelectionModal.From = DateHelper.getUTCDateString(
                        DateHelper.getNativeDate(this.FromDate)
                    );
                } else {
                    this.taskSelectionModal.From = '';
                }
                if (this.ToDate !== null) {
                    this.taskSelectionModal.To = DateHelper.getUTCDateString(
                        DateHelper.getNativeDate(this.ToDate)
                    );
                } else {
                    this.taskSelectionModal.To = '';
                }

                url = `${API.Selection.getTaskSelection}`;

                if (initialCall) {
                    return this.apiService.post(url, this.taskSelectionModal);
                } else {
                    return this.apiService.post(url, this.taskResultModal);
                }

            default:
                return null;
        }
    }

    public GetAttributeList(companyId): Observable<RestResponse> {
        const url = `${API.Selection.getAttributeList}?CompanyId=${companyId}`;
        return this.apiService.get(url);
    }

    public GetDoctorList(): Observable<RestResponse> {
        const url = `${API.Doctor.getDoctorList}`;
        return this.apiService.get(url);
    }

    public GetCoordinatorList(): Observable<RestResponse> {
        const url = `${API.Coordinator.getActiveCoordinator}`;
        return this.apiService.get(url);
    }

    public GetDiagnosisTree(): Observable<RestResponse> {
        const url = `${API.Diagnosis.getDiagnosisFilterTree}`;
        return this.apiService.get(url);
    }

    public resetEmployeeMoreFilterValues(): void {
        this.employeeSelectionModal.AttributeList = [];
    }

    public GetUsuarioList(): Observable<RestResponse> {
        const url = `${API.auth.getAbreviacionList}`;
        return this.apiService.get(url);
    }

    public resetActuationMoreFilterValues(): void {
        this.ActuationSelectionModal.RegistroDateFrom = undefined;
        this.ActuationSelectionModal.RegistroDateTo = undefined;
        this.ActuationSelectionModal.FechaRevisionDateFrom = undefined;
        this.ActuationSelectionModal.FechaRevisionDateTo = undefined;
        this.ActuationSelectionModal.Usuario = '';
        this.ActuationSelectionModal.Coordinador = '';
        this.ActuationSelectionModal.IsRevisadas = false;
        this.ActuationSelectionModal.IsConComentarios = false;
        this.ActuationSelectionModal.IsConOrdenes = false;
        this.ActuationSelectionModal.IsConceptosFacturables = false;
        this.ActuationSelectionModal.FacturacionRadioButton = '';
        this.ActuationSelectionModal.FacturacionFraCentro = '';
        this.ActuationSelectionModal.AttributeList = [];
        this.ActuationSelectionModal.PeriodoDeBajaDateFrom = '';
        this.ActuationSelectionModal.PeriodoDeBajaDateTo = '';
        this.ActuationSelectionModal.ActivityTypes = new Array<TreeView>();
        this.ActuationSelectionModal.LeaveType = '';
        this.ActuationSelectionModal.Gestor = '';
        this.ActuationSelectionModal.EmpresaCoordinador = '';
        this.ActuationSelectionModal.Provincia = '';
        this.ActuationSelectionModal.Poblacion = '';
    }

    public resetLeaveMoreFiltersValues(): void {
        this.leaveSelectionModal.AttributeList = [];
        this.leaveSelectionModal.IsNoDiagnosis = false;
        this.leaveSelectionModal.NoDiagnosisReason = '';
        this.leaveSelectionModal.MedicoId = undefined;
        this.leaveSelectionModal.Weekday = undefined;
        this.leaveSelectionModal.WeekdayCount = undefined;
        this.leaveSelectionModal.LeaveDaysFrom = undefined;
        this.leaveSelectionModal.LeaveDaysTo = undefined;
        this.leaveSelectionModal.LeaveEndOfPeriodDaysFrom = undefined;
        this.leaveSelectionModal.LeaveEndOfPeriodDaysTo = undefined;
        this.leaveSelectionModal.LeaveInPeriodDaysFrom = undefined;
        this.leaveSelectionModal.LeaveInPeriodDaysTo = undefined;
        this.leaveSelectionModal.LaborDaysFrom = undefined;
        this.leaveSelectionModal.LaborDaysTo = undefined;
        this.leaveSelectionModal.LaborEndOfPeriodDaysFrom = undefined;
        this.leaveSelectionModal.LaborEndOfPeriodDaysTo = undefined;
        this.leaveSelectionModal.LaborInPeriodDaysFrom = undefined;
        this.leaveSelectionModal.LaborInPeriodDaysTo = undefined;
        this.leaveSelectionModal.LeaveCommunicationGapDaysFrom = undefined;
        this.leaveSelectionModal.LeaveCommunicationGapDaysTo = undefined;
        this.leaveSelectionModal.MarcaList = [];
        this.leaveSelectionModal.LeaveType = '';
        this.leaveSelectionModal.Consentimiento = '';
        this.leaveSelectionModal.DiagnosisFrom = '';
        this.leaveSelectionModal.DiagnosisTo = '';
        this.leaveSelectionModal.CommunicationDateFrom = '';
        this.leaveSelectionModal.CommunicationDateTo = '';
        this.leaveSelectionModal.DischargeDateFrom = '';
        this.leaveSelectionModal.DischargeDateTo = '';
        this.leaveSelectionModal.NewLeaveDateFrom = '';
        this.leaveSelectionModal.NewLeaveDateTo = '';
        this.leaveSelectionModal.PsychosocialRisks = '';
        this.leaveSelectionModal.Gestor = '';
        this.leaveSelectionModal.Coordinador = '';
        this.leaveSelectionModal.Provincia = '';
        this.leaveSelectionModal.Poblacion = '';
    }

    public resetTaskMoreFilterValues(): void {
        this.taskSelectionModal.TaskType = new Array<TreeView>();
        this.taskSelectionModal.FPAFromDate = null;
        this.taskSelectionModal.FPAToDate = null;
        this.taskSelectionModal.DiasFrom = null;
        this.taskSelectionModal.DiasTo = null;
        this.taskSelectionModal.LeaveType = '';
        this.taskSelectionModal.Provincia = '';
        this.taskSelectionModal.Poblacion = '';
    }

    public GetSelectionExcel(): Observable<RestResponse> {
        let url = '';
        switch (this.sharedService.selectedSelectionTabId) {
            case 1:
                this.employeeSelectionModal.ColumnsList=this.employeeService.trabadoreColumns;
                this.employeeSelectionModal.EmpresaID = Number(
                    this.selectedCompanyId
                );
                url = `${API.Selection.getEmployeeSelectionExcel}`;
                return this.apiService.post(url, this.employeeSelectionModal);

            case 2:
                this.leaveSelectionModal.ColumnsList=this.leaveService.leaveColumns;
                this.leaveSelectionModal.EmpresaID = Number(
                    this.selectedCompanyId
                );
                url = `${API.Selection.getLeaveSelectionExcel}`;
                return this.apiService.post(url, this.leaveSelectionModal);

            case 3:
                this.ActuationSelectionModal.ColumnsList=this.actuationService.acctuacionColumns;
                this.ActuationSelectionModal.EmpresaID = Number(
                    this.selectedCompanyId
                );
                url = `${API.Selection.getActuationExcel}`;
                return this.apiService.post(url, this.ActuationSelectionModal);

            case 5:
                this.taskSelectionModal.ColumnsList=this.taskService.tasksColumns;
                this.taskSelectionModal.CompanyId = Number(
                    this.selectedCompanyId
                );
                url = `${API.Selection.getTaskSelectionExcel}`;
                return this.apiService.post(url, this.taskSelectionModal);

            default:
                return null;
        }
    }

    transferTasks(
        transferType: TaskTransferTypes,
        transferValue: string
    ): Observable<RestResponse> {
        let url = `${API.Selection.transferTasks}`;
        url = url.replace('{transferType}', transferType.toString());
        url = url.replace('{transferValue}', transferValue);
        return this.apiService.put(url, this.taskResultModal);
    }

    changeTasks(changeTaskModel: ChangeTaskModel): Observable<RestResponse> {
        const url = API.Selection.changeTasks as string;
        return this.apiService.put(url, changeTaskModel);
    }

    public toggleRecordingsPanel(): void {
        this.isRecordingsVisible = this.isRecordingsVisible ? false : true;
        if (this.isRecordingsVisible) {
            this.isShowLeavePanel = false;
        }
        this.showSidePanelEmitter.emit(this.isRecordingsVisible);
    }

    public hideRecordingsPanel(): void {
        this.isRecordingsVisible = false;
        this.showSidePanelEmitter.emit(this.isRecordingsVisible);
    }

    public GestorList(): Observable<RestResponse> {
        const url = `${API.Selection.gestorList}`;
        return this.apiService.get(url);
    }

    public PoblacionList(): Observable<RestResponse> {
        const url = `${API.Selection.poblacionList}`;
        return this.apiService.get(url);
    }
}
